module.exports = __webpack_public_path__ + "img/security-camera.d833affc.svg";